export const SINGLE_HARVEST_ROOTED='SingleHarvestRooted';

export const SINGLE_HARVEST_CUT='SingleHarvestCut';

export const MULTI_HARVEST_CUT='MultiHarvestCut';

export const harvestingProcedureTypes = [SINGLE_HARVEST_ROOTED, SINGLE_HARVEST_CUT, MULTI_HARVEST_CUT];

